import {Alias} from './alias.js';
import {LayoutConfig} from '../layout/config';
import {ResourcesConfig} from './resources/config';
import {app} from './app.js';
import {RegexUtils} from '../shared/utils/RegexUtils';
import {assign as _assign} from 'lodash';
import {GraphqlConfig} from './resources/GraphqlConfig';
import {APP_FEATURES} from './resources/SessionObjects';

class Router extends Backbone.Router {

    routes () {

        return {

            ':countryCode/:languageCode/smart-sprayer-landing(/)': Alias.V2_APP,
            ':countryCode/:languageCode/smart-sprayer-registration(/)': Alias.V2_APP,

            ':countryCode/:languageCode/farm/dashboard(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/dashboard/:selectedPage(/)': Alias.V2_APP,

            ':countryCode/:languageCode/farm/fields(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/field/status(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/field/weather(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/fdl(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/shop/products(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/healthy-fields/dashboard(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/healthy-fields/overview(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/field/draw(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/field/detect(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/field/upload(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/crop-season/assign(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task/add/observation(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task/add/spraying(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task/add/herbicide(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task/add/drone(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task/add/nutrition(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/task/add/scouting(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/user(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/licenses(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/downloads(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/connections(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/farm(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/collaboration(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/weather-stations(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/scouting(/)': Alias.FORWARD_LAYOUT,
            ':countryCode/:languageCode/farm/settings/data-attribution(/)': Alias.FORWARD_LAYOUT,

            ':countryCode/:languageCode/farm/:farmUuid/field/status(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/fields(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/fields(/):fieldUuid(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/fields(/):fieldUuid/:cropSeasonUuid(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/expert/:fieldUuid(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/seeding(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/seeding(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/seed-treatment(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/seed-treatment(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/seedbox-treatment(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/seedbox-treatment(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/land-preparation(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/land-preparation(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/notes(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/notes/:fieldUuid/add(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/notes/:fieldUuid/edit(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/dashboard(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/farm(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/user-profile(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/collaboration(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/licenses(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/xconnect(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/fdl(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/field/upload(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/field/upload/success(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/crop-season/assign/start(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/crop-season/assign/details(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/crop-season/assign/crop(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/crop-season/edit(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/cropseason-treatment-programs(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/cropseason-treatment-program-creation(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/cropseason-treatment-program-recommendations(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/harvest-task(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/harvest-task(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/sustainability(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/weather-stations(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/field/management-zones-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/drone(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/drone(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/crop-protection(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/crop-protection(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/nutrition-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/nutrition-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/scouting-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/scouting-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/settings/connections(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/shop/products(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/shop/order(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/shop/products-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/shop/order-new(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/new-overview(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/new-services(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/new-request(/)': Alias.V2_APP,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/new-contractor-request(/)': Alias.V2_APP,

            ':countryCode/:languageCode/farm/:farmUuid/field/draw(/)': Alias.DRAW,
            ':countryCode/:languageCode/farm/:farmUuid/field/draw/success(/)': Alias.DRAW_SUCCESS,
            ':countryCode/:languageCode/farm/:farmUuid/field/detect(/)': Alias.BOUNDARY_DETECTION,
            ':countryCode/:languageCode/farm/:farmUuid/field/detect/success(/)': Alias.BOUNDARY_DETECTION_SUCCESS,
            ':countryCode/:languageCode/farm/:farmUuid/field/edit/:fieldUuid(/)': Alias.EDIT_FIELD,
            ':countryCode/:languageCode/farm/:farmUuid/field/create(/)': Alias.CREATE,
            ':countryCode/:languageCode/farm/:farmUuid/field/weather(/)': Alias.WEATHER,
            ':countryCode/:languageCode/farm/:farmUuid/field/management-zones(/)': Alias.MANAGEMENT_ZONES,
            ':countryCode/:languageCode/farm/:farmUuid/field/management-zones/draw': Alias.DRAW_MANAGEMENT_ZONES,
            ':countryCode/:languageCode/farm/:farmUuid/field/management-zones/edit/:fieldZoneUuid(/)': Alias.EDIT_MANAGEMENT_ZONES,
            ':countryCode/:languageCode/farm/:farmUuid/field/reference-lines(/)': Alias.AB_LINES,
            ':countryCode/:languageCode/farm/:farmUuid/field/reference-lines/draw-ab-line': Alias.DRAW_AB_LINES,
            ':countryCode/:languageCode/farm/:farmUuid/field/reference-lines/edit-ab-line/:abLineUuid(/)': Alias.EDIT_AB_LINES,
            ':countryCode/:languageCode/farm/:farmUuid/field/reference-lines/draw-tramline': Alias.DRAW_TRAMLINES,
            ':countryCode/:languageCode/farm/:farmUuid/field/reference-lines/edit-tramline/:tramlineUuid(/)': Alias.EDIT_TRAMLINES,
            ':countryCode/:languageCode/farm/:farmUuid/field/field-entries(/)': Alias.FIELD_ENTRIES,
            ':countryCode/:languageCode/farm/:farmUuid/field/field-entries/add': Alias.ADD_FIELD_ENTRIES,
            ':countryCode/:languageCode/farm/:farmUuid/field/field-entries/edit/:fieldEntryUuid(/)': Alias.EDIT_FIELD_ENTRIES,
            ':countryCode/:languageCode/cfd/crop-season/assign(/)': Alias.ASSIGN_CS,
            ':countryCode/:languageCode/farm/:farmUuid/crop-season/assign(/)': Alias.ASSIGN_CS,
            ':countryCode/:languageCode/farm/crop-season/edit(/)': Alias.EDIT_CS,
            ':countryCode/:languageCode/farm/:farmUuid/crop-season/timing/:cropSeasonUuid(/)': Alias.TIMING,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/nutrition(/)': Alias.TASK_NUTRITION_CREATE,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/nutrition(/)': Alias.TASK_NUTRITION_EDIT,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/observation(/)': Alias.TASK_OBSERVATION_CREATE,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/spraying(/)': Alias.TASK_SPRAYING_CREATE,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/herbicide(/)': Alias.TASK_HERBICIDE_CREATE,
            ':countryCode/:languageCode/farm/:farmUuid/task/add/scouting(/)': Alias.TASK_SCOUTING_CREATE,
            ':countryCode/:languageCode/cfd/task/add/spraying(/)': Alias.TASK_SPRAYING_CREATE,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/spraying(/)': Alias.TASK_SPRAYING_EDIT,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/herbicide(/)': Alias.TASK_HERBICIDE_EDIT,
            ':countryCode/:languageCode/farm/task/edit/spraying(/)': Alias.TASK_SPRAYING_EDIT,
            ':countryCode/:languageCode/farm/task/edit/herbicide(/)': Alias.TASK_HERBICIDE_EDIT,
            ':countryCode/:languageCode/farm/:farmUuid/task/edit/scouting(/)': Alias.TASK_SCOUTING_EDIT,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/overview(/)': Alias.HEALTHY_FIELDS_OVERVIEW,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/services(/)': Alias.HEALTHY_FIELDS_SERVICES,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/request(/)': Alias.HEALTHY_FIELDS_REQUEST,
            ':countryCode/:languageCode/farm/:farmUuid/healthy-fields/contractor-request(/)': Alias.HEALTHY_FIELDS_CONTRACTOR_REQUEST,
            ':countryCode/:languageCode/farm/:farmUuid/fdl-upload(/)': Alias.FDL_UPLOADS,
            ':countryCode/:languageCode/farm/:farmUuid/settings/user(/)': Alias.USER_SETTINGS,
            ':countryCode/:languageCode/farm/:farmUuid/settings/downloads(/)': Alias.DOWNLOAD_HISTORY,
            ':countryCode/:languageCode/farm/:farmUuid/settings/scouting(/)': Alias.SCOUTING,
            ':countryCode/:languageCode/farm/:farmUuid/settings/data-attribution(/)': Alias.DATA_ATTRIBUTION,
            ':countryCode/:languageCode/under-construction(/)': Alias.UNDER_CONSTRUCTION,
            ':countryCode/:languageCode/support/reset/cache(/)': Alias.RESET_CACHE,
            ':countryCode/:languageCode/error-403(/)': Alias.NOT_AUTHORIZED,
            ':countryCode/:languageCode/error-404(/)': Alias.PAGE_NOT_FOUND,
            ':countryCode/:languageCode/tc-accepted(/)': Alias.TC_ACCEPTED,
            ':countryCode/:languageCode/xconnect(/)': Alias.V2_APP,
            ':countryCode/:languageCode/*404': Alias.PAGE_NOT_FOUND,
            '*404': Alias.PAGE_NOT_FOUND
        };
    }

    initialize (options) {

        this._events = [];
    }

    start () {

        Backbone.history.start({
            pushState: true
        });
    }

    _routeToRegExp(route) {

        let self = this;

        /**
         * Cached regular expressions for matching named param parts and splatted
         * parts of route strings.
         */
        let namedParam = /(\(\?)?:\w+/g;
        let splatParam = /\*\w+/g;
        let escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
        let optionalParam = /\((.*?)\)/g;
        let pattern;

        this.parsedParamNames = [];

        route = route.replace(escapeRegExp, '\\$&')
            .replace(optionalParam, '(?:$1)?')
            .replace(namedParam, function(match, optional) {
                self.parsedParamNames.push(match.replace(':', ''));
                return optional ? match : '([^/?]+)';
            })
            .replace(splatParam, '([^?]*?)');
        pattern = '^' + route + '(?:\\?([\\s\\S]*))?$';

        return RegexUtils.safeRegEx(pattern);
    }

    route (route, name, callback) {

        let self = this;
        let namedParamsExtractor = null;

        if (!_.isRegExp(route)) {
            route = this._routeToRegExp(route);
            namedParamsExtractor = this.createNamedParamsExtractor();
        }

        if (_.isFunction(name)) {
            callback = name;
            name = '';
        }

        if (!callback) {
            callback = this[name];
        }

        Backbone.history.route(route, function(fragment) {

            let args = self._extractParameters(route, fragment);
            let routeEvent = {
                routeName: name,
                routeArgs: args,
                queryParams: self.parseQueryString(window.location.search),
                routeNamedArgs: namedParamsExtractor(args),
                fragment: fragment
            };

            if (name === Alias.FORWARD) {

                self.forwardRoute(routeEvent);
                return;
            }

            if (self.processRoute(routeEvent) !== false) {

                self.trigger.apply(self, ['route:' + name].concat(args));
                self.trigger('route', name, args);
                Backbone.history.trigger('route', self, name, args);
            }
        });

        return this;
    }

    createNamedParamsExtractor () {

        let names = this.parsedParamNames;

        return function (args) {

            let namedArgs = {};

            names.forEach((name, index) => {
                namedArgs[name] = args[index];
            });

            return namedArgs;
        };
    }

    /**
     * @description Main route processor, will be called for each route, will do
     *    * load default resources
     *    * load route-specific resources
     *    * render layout
     *
     * @param {RouteEvent} routeEvent
     */
    processRoute (routeEvent) {

        let self = this;
        let routerChannel = Radio.channel('ROUTER');
        let resourcesToLoad = null;
        let loadResources = true;

        if (routeEvent.routeName === Alias.PAGE_NOT_FOUND) {

            if (routeEvent && routeEvent.routeNamedArgs) {

                let countryCode = routeEvent.routeNamedArgs.countryCode;
                let languageCode = routeEvent.routeNamedArgs.languageCode;
                let fragment = routeEvent.fragment;

                if (countryCode && languageCode) {

                    let path = fragment.substring(8);

                    if (path === '' ||
                        path === '/' ||
                        path.startsWith('/login') ||
                        path.startsWith('/registration') ||
                        path.startsWith('/registration-2019') ||
                        path.startsWith('/hf-contractor') ||
                        path.startsWith('/registration-hf') ||
                        path.startsWith('/forgot-password') ||
                        path.startsWith('/reset-password') ||
                        path.startsWith('/email-verified') ||
                        path.startsWith('/set-password') ||
                        path.startsWith('/complete-registration') ||
                        path.startsWith('/accept-tc') ||
                        path.startsWith('/registrations-closed')) {

                        window.location.href = window.location.origin + '/' + routeEvent.fragment;
                        window.location.reload();
                        return;
                    }
                } else if (fragment.startsWith('reset-password') || fragment.startsWith('/payment')) {

                    window.location.href = window.location.origin + '/' + routeEvent.fragment;
                    window.location.reload();
                    return;
                }
            }
        }

        let layoutAppFeature = LayoutConfig.getLayoutClassAppFeature(routeEvent);

        if (layoutAppFeature) {
            let isFeatureDisabled = APP_FEATURES.isFeatureDisabled({
                feature: layoutAppFeature,
                country: routeEvent.routeNamedArgs && routeEvent.routeNamedArgs.countryCode
            });

            if (isFeatureDisabled) {
                self.setLastEvent(routeEvent);
                self.setLastEventCountry(routeEvent);
                self.navigateRelativelyToLocaleCode('/' + Alias.NOT_AUTHORIZED);
                return;
            }
        }

        routerChannel.trigger('ROUTE:START', routeEvent, loadResources);
        self.setLastEvent(routeEvent);
        self.setLastEventCountry(routeEvent);

        let defaultResourcesToLoad = ResourcesConfig.getResourceListToLoad('default', routeEvent);
        let routeResourcesToLoad = ResourcesConfig.getResourceListToLoad(routeEvent.routeName, routeEvent);
        let resourceList = _.concat(defaultResourcesToLoad, routeResourcesToLoad);

        resourcesToLoad = GraphqlConfig.fetchData(resourceList, routeEvent);
        resourcesToLoad.done((resources) => {

            let resourceLocator = app.getResourceLocator();

            self.packResources(resourceLocator, resourceList, routeEvent, resources);
            self.injectContent(routeEvent, loadResources);

            routerChannel.trigger('ROUTE:FINISH', routeEvent);

            if (_.isFunction(window.ga)) {
                window.ga('send', 'pageview');
            }
        });
    }

    /**
     * @description Will forward route to some other. Can be used for url schema migration
     *
     * @param {RouteEvent} routeEvent
     */
    forwardRoute (routeEvent) {

        let targetUrl = this._buildForwardUrl(document.location.pathname, routeEvent);

        if (targetUrl) {

            document.location.href = ('/' + targetUrl);
        }
        else {

            // TODO: create 404 page
        }
    }

    _buildForwardUrl (path, routeEvent) {

        if (String(path).indexOf('reset-password') !== -1
            && routeEvent.queryParams.languageCode
            && routeEvent.queryParams.countryCode
            && routeEvent.queryParams.apiKey
            && routeEvent.queryParams.email
            && routeEvent.queryParams.pwrt
        ) {

            return (
                (routeEvent.queryParams.countryCode + '/') +
                (routeEvent.queryParams.languageCode + '/') +
                'reset-password?' +
                ('pwrt=' + routeEvent.queryParams.pwrt + '&') +
                ('email=' + routeEvent.queryParams.email + '&') +
                ('apiKey=' + routeEvent.queryParams.apiKey)
            );
        }

        if (String(path).indexOf('set-password') !== -1
            && routeEvent.queryParams.languageCode
            && routeEvent.queryParams.countryCode
            && routeEvent.queryParams.apiKey
            && routeEvent.queryParams.email
            && routeEvent.queryParams.pwrt
        ) {

            return (
                (routeEvent.queryParams.countryCode + '/') +
                (routeEvent.queryParams.languageCode + '/') +
                'set-password?' +
                ('pwrt=' + routeEvent.queryParams.pwrt + '&') +
                ('email=' + routeEvent.queryParams.email + '&') +
                ('apiKey=' + routeEvent.queryParams.apiKey)
            );
        }

        return '';
    }

    packResources (resourceLocator, allResources, routeEvent, loadedResources = []) {

        loadedResources = (_.isArray(loadedResources) ? loadedResources : [loadedResources]);
        loadedResources.forEach(function (resource, index) {

            let resourceConfig = allResources[index];
            let key = (typeof resourceConfig === 'string' ? resourceConfig : resourceConfig.source);

            resourceLocator.set(key, resource);
        });
    }

    injectContent (routeEvent, loadResources = true) {

        let rootLayout = app.getView();

        if (loadResources) {

            LayoutConfig.getLayout(routeEvent)
                .done((LayoutClass) => {

                    rootLayout.showChildView('content', new LayoutClass({
                        model: app.getResourceLocator(),
                        routeEvent: routeEvent
                    }));
                })
                .fail((errorMessage) => {

                    // To be verified if we upgrade the webpack version
                    let chunkFailedRegex = /^Loading chunk.*failed\./gi;

                    if (chunkFailedRegex.test(errorMessage)) {
                        window.location.reload();
                    } else {
                        Radio.channel('NOTIFICATION').trigger('NOTIFY', {
                            content: __('SMTH_WRONG')
                        });
                    }

                    console.warn(errorMessage);
                });
        } else {
            // Individual layouts to implement this method if necessary
            rootLayout.getChildView('content').triggerMethod('re:inject', routeEvent);
        }
    }

    buildQueryString (params) {

        let queryItems = _.map(params, function (value, key) {

            if (key && value) {
                return key + '=' + encodeURIComponent(value);
            }

            return '';
        });

        return _.filter(queryItems, (item) => (item !== '')).join('&');
    }

    parseQueryString (query = '') {

        let params = {};

        if (query[0] == '?') {
            query = query.substr(1);
        }

        query.split('&').forEach(function (part) {

            if (part !== '') {

                let match = part.split('=');

                params[ match[0] ] = decodeURIComponent(_.tail(match).join('='));
            }
        });

        return params;
    }

    getQueryParam (key, defaultValue) {

        let query = this.parseQueryString(location.search);

        if (_.isUndefined(key)) {
            return query;
        }
        else {
            return (_.isUndefined(query[key]) ? defaultValue : query[key]);
        }
    }

    getArrayQueryParam (key, defaultValue) {

        let param = this.getQueryParam(key);

        if (_.isString(param) && param.length) {

            return param.split(',');
        }
        else {

            return defaultValue;
        }
    }

    /**
     * @description Returns last route event processed by the app
     * @returns {RouteEvent|Object}
     */
    getLastEvent () {

        let lastEvent = {};

        if (this._events.length > 0) {
            lastEvent = _.clone(this._events[this._events.length - 1]);
        }

        return lastEvent;
    }

    /**
     * @description Returns previous route event processed by the app
     * @returns {RouteEvent|Object}
     */
    getPrevEvent () {

        let prevEvent = {};

        if (this._events.length > 1) {
            prevEvent = _.clone(this._events[this._events.length - 2]);
        }

        return prevEvent;
    }

    /**
     * @description Pushed the last event processed by the app into the history
     * @param lastEvent
     */
    setLastEvent (lastEvent = {}) {

        this._events.push(lastEvent);
    }

    /**
     * @description Get country code from last event
     * @returns {string|undefined}
     */
    getLastEventCountryCode () {

        return this._countryCode;
    }

    /**
     * @description Get language code from last event (like "en_de")
     * @returns {string}
     */
    getLastEventLanguageCode () {
        let event = this.getLastEvent();

        if (event && event.routeNamedArgs && event.routeNamedArgs.languageCode) {
            return event.routeNamedArgs.languageCode;
        }
    }

    /**
     * @description Get 2 char language code from last event (like "en")
     * @returns {string}
     */
    getLastEventLanguage2Char () {
        let languageCode = this.getLastEventLanguageCode();

        if (languageCode) {
            return languageCode.split('_')[0];
        }
    }

    /**
     * @description Set country code from last event
     * @param lastEvent
     */
    setLastEventCountry (lastEvent = {}) {

        if (lastEvent && lastEvent.routeNamedArgs) {
            this._countryCode = lastEvent.routeNamedArgs.countryCode;
        } else {
            delete this._countryCode;
        }
    }

    /**
     * @description Returns number of events processed by the app
     * @return {Number}
     */
    countEvents () {

        return this._events.length;
    }

    /**
     * @description Returns copy of events processed by the app
     * @return {RouteEvent[]}
     */
    getEvents () {

        return _.clone(this._events);
    }

    /**
     * @description Navigates to the current path but with updated param set.
     *
     * @param {Object}  options    - Hash of params to replace in URL
     * @param {Boolean} hardUpdate - If set to true all current query string in URL will be replaced with
     * @param {Boolean} replace    - Replaced flag to be passed to Router.navigate()
     */
    updateURL (options, hardUpdate, replace) {

        let params = {};

        let currentParams = {};
        let targetPath = '';
        let query = '';

        hardUpdate = (typeof hardUpdate === 'boolean' ? hardUpdate : false);
        replace = replace || false;

        if (!options.paramsToUpdate) {
            options.paramsToUpdate = {};
        }

        currentParams = this.parseQueryString(window.location.search);

        Object.keys(options.paramsToUpdate).forEach(function(key) {
            currentParams[key] = options.paramsToUpdate[key];
        });

        params = currentParams;

        if (hardUpdate === true) {

            _.difference(_.keys(params), _.keys(options.paramsToUpdate)).forEach(function (key) {
                delete params[key];
            });
        }

        query = this.buildQueryString(params);

        targetPath += (options.pathFragment ? options.pathFragment : this.getCurrentPathFragment());
        targetPath += (query !== '' ? ('?' + query) : '');

        this.navigate(targetPath, {trigger: false, replace: replace});
    }

    /**
     * Get locale path prefix, like "/de/en_de/"
     * @returns {string}
     */
    getLocalePrefix () {
        let countryCode = this.getLastEventCountryCode();
        let languageCode = this.getLastEventLanguageCode();

        return (countryCode && languageCode) ? `/${countryCode}/${languageCode}/` : '/';
    }

    navigateRelativelyToLocaleCode (route, settings = {trigger : true, mergeQueryParams : false}, {disableSameRouteReload} = {}) {

        let routeEvent = this.getLastEvent();
        let args = routeEvent.routeNamedArgs;

        if(ENV === 'demo') {
            return;
        }

        if (args && args.countryCode && args.languageCode) {

            let oldRoute = routeEvent.fragment;
            let newRoute = `${args.countryCode}/${args.languageCode}${route}`;

            if (settings.mergeQueryParams) {

                let routeParts = newRoute.split('?');
                let query = this.buildQueryString(_assign({}, routeEvent.queryParams, this.parseQueryString(routeParts[1])));

                newRoute = `${routeParts[0]}?${query}`;
            }

            if (oldRoute === newRoute && !disableSameRouteReload) {
                Backbone.history.loadUrl(oldRoute);
            } else {
                this.navigate(`/${newRoute}`, settings);
            }
        } else if (window.location.pathname.match(/([a-z]{2})\/([a-z]{2}_[a-z]{2})(\/.*)/)) {

            window.location.href = window.location.origin + window.location.pathname.substring(0, 9) + route;
            window.location.reload();
        } else {
            this.navigate('/', settings);
        }
    }

    getCurrentPathFragment () {

        return location.pathname;
    }

    broadcastSectionChange (options) {
        let routerChannel = Radio.channel('ROUTER');

        routerChannel.trigger('ROUTE:SECTION:CHANGE', options);
    }

    getReversedEvents() {

        return [...this._events].reverse();
    }

    getFragmentWithoutLocale(fragment) {
        
        fragment = fragment.startsWith('/')
            ? fragment
            : '/' + fragment;

        const fragmentArr = fragment
            .replace(router.getLocalePrefix(), '')
            .split('/')
            .filter((x) => x !== '');

        return {
            fragment: fragmentArr.join('/'),
            fragmentArr,
        };
    }

    routeToPrevPage() {
        const prevEvent = this.getPrevEvent();
        
        if(prevEvent && Object.keys(prevEvent).length) {
            const {fragment} = this.getFragmentWithoutLocale(prevEvent.fragment);

            this.navigateRelativelyToLocaleCode(`/${fragment}`);
        }
        else {
            this.navigateRelativelyToLocaleCode('/login');    // login will automatically redirect the user to the status page if he is logged in
        }
    }

    swapLastRoutePart(part) {
        const pathArr = this.getCurrentPathFragment()
            .replace(this.getLocalePrefix(), '')
            .split('/')
            .filter(x => x !== '');

        pathArr.pop();

        const newPath = '/' + pathArr.join('/') + '/' + part;

        return newPath;
    }
}

var router = new Router();

export {router};



// WEBPACK FOOTER //
// ./js/router.js